interface SidePanelProcessDescription {
	processType: 'Side Panel';
	windowId: number;
}

interface ServiceWorkerProcessDescription {
	processType: 'Service Worker';
}

interface ReportPageProcessDescription {
	processType: 'Report Page';
}

interface ContentScriptProcessDescription {
	processType: 'Content Isolated' | 'Content Main';
}

interface OffscreenScriptProcessDescription {
	processType: 'Offscreen Page';
}

interface DevToolsPageScriptProcessDescription {
	processType: 'DevTools Page';
}

interface SearchWebWorkerProcessDescription {
	processType: 'Search Web Worker';
}

interface ExtensionUIProcessDescription {
	processType: 'Extension UI';
}

interface PopupProcessDescription {
	processType: 'Popup';
}

export type ProcessInfoType = SidePanelProcessDescription |
	PopupProcessDescription |
	ServiceWorkerProcessDescription |
	ReportPageProcessDescription |
	ContentScriptProcessDescription |
	OffscreenScriptProcessDescription |
	DevToolsPageScriptProcessDescription |
	SearchWebWorkerProcessDescription |
	ExtensionUIProcessDescription
	;

// const getLogTime = (): string => {
// 	return `${((Date.now() % 1000000000) / 1000).toFixed(3)}s`;
// }

export class ProcessInfo {
	public static setProcess(info: ProcessInfoType | {processType: string}) {
		const header = info.processType === "Content Isolated" || info.processType === "Content Main" ?
				`[${info.processType} at ${window.location.origin}${window.location.pathname}]:\n\t` :
				`[${info.processType}]: `;
	
		ProcessInfo.log = Function.prototype.bind.call(console.log, console, header);
		ProcessInfo.errorLog = Function.prototype.bind.call(console.error, console, header);
	}
	
	static log = Function.prototype.bind.call(console.log, console) as typeof console.log;
	static errorLog = Function.prototype.bind.call(console.error, console) as typeof console.error;

	private static lastMsReported = performance.now();
	static resetTime = () => {
		ProcessInfo.lastMsReported = performance.now();
	}
	static updateTime = () => {
		const now = performance.now();
		const result = now - ProcessInfo.lastMsReported;
		ProcessInfo.lastMsReported = now;
		return result;
	}

}
